// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__m4clV"};